export default "__VITE_ASSET__DSg$JoZu__"